"use client"

import type { ReactNode } from "react"
import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area"

/**
 * A vertical scroll area whose thin thumb floats over the content and shows
 * only while scrolling. Unlike a native scrollbar it takes no width, so rows
 * and dividers reach the edge. Size it with `viewportClassName`, such as a
 * max height; frame it with `className`.
 */
export function ScrollArea({
  className,
  viewportClassName,
  children,
}: {
  className?: string
  viewportClassName?: string
  children: ReactNode
}) {
  return (
    <BaseScrollArea.Root className={`relative overflow-hidden ${className ?? ""}`}>
      <BaseScrollArea.Viewport
        className={`overscroll-contain outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-kumo-ring ${viewportClassName ?? ""}`}
      >
        {children}
      </BaseScrollArea.Viewport>
      <BaseScrollArea.Scrollbar
        orientation="vertical"
        className="flex w-2.5 justify-center py-1 opacity-0 transition-opacity duration-500 data-[scrolling]:opacity-100 data-[scrolling]:duration-0"
      >
        <BaseScrollArea.Thumb className="w-1.5 rounded-full bg-(--color-kumo-scroll-thumb)" />
      </BaseScrollArea.Scrollbar>
    </BaseScrollArea.Root>
  )
}
